/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Relativemonthagoone3Inputs */

const en_relativemonthagoone3 = /** @type {(inputs: Relativemonthagoone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 month ago`)
};

const pt_relativemonthagoone3 = /** @type {(inputs: Relativemonthagoone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`há 1 mês`)
};

/**
* | output |
* | --- |
* | "1 month ago" |
*
* @param {Relativemonthagoone3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const relativemonthagoone3 = /** @type {((inputs?: Relativemonthagoone3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relativemonthagoone3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relativemonthagoone3(inputs)
	return pt_relativemonthagoone3(inputs)
});
export { relativemonthagoone3 as "relativeMonthAgoOne" }